import { render } from "./Styleguide.vue?vue&type=template&id=41f8704a"
import script from "./Styleguide.vue?vue&type=script&lang=js"
export * from "./Styleguide.vue?vue&type=script&lang=js"

import "./Styleguide.vue?vue&type=style&index=0&id=41f8704a&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__